import { makeStyles } from '@material-ui/core';
import accionaLogoHome from './logo/logo-acciona.svg';
import deboxLogoHome from './logo/logo_debox.png';
import accionaLogoHomeNegative from './logo/acciona_logo_full_negative.png';
import { appThemeApiRef, useApi } from '@backstage/core-plugin-api';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 190,
    justifySelf: 'flex-start',
    marginLeft: -45,
  },
});

export const LogoFullAcciona = () => {
  const themeApi = useApi(appThemeApiRef);
  const themeId = themeApi.getActiveThemeId();

  const logo =
    themeId === 'accionaDarkTheme'
      ? deboxLogoHome
      : deboxLogoHome;
  const classes = useStyles();
  return <img src={logo} alt="Acciona Logo" className={classes.svg} />;
};

export const LogoFullAccionaHome = () => {
  const themeApi = useApi(appThemeApiRef);
  const themeId = themeApi.getActiveThemeId();

  const logo =
    themeId === 'accionaDarkTheme'
      ? accionaLogoHomeNegative
      : accionaLogoHome;
  return <img src={logo} alt="Acciona Logo" style={{ width: 'auto', height: 130 }} />;
};
